import { render, staticRenderFns } from "./ShippingMethods.vue?vue&type=template&id=9515d1e0&scoped=true"
import script from "./ShippingMethods.vue?vue&type=script&lang=js"
export * from "./ShippingMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9515d1e0",
  null
  
)

export default component.exports